import React from 'react';
import { Tag } from '@fiverr-private/tag_collection';

export enum AISummaryMode {
    NONE,
    IMPRESSION,
    DISPLAY,
}

export interface ContactTriggerChildrenProps {
    onClick: () => void;
}

export interface ContactTriggerProps {
    onClick: () => void;
    children: (props: ContactTriggerChildrenProps) => React.ReactNode;
}

export interface SellerInfo {
    sellerUrl: string;
    username: string;
    sellerName: string;
    isAgency: boolean;
    completedOrders: number;
    description: string;
    ContactTrigger: React.FC<ContactTriggerProps>;
    tags?: Tag[];
    skills?: Tag[];
    introVideoUrl?: string;
    location?: string;
    title?: string;
    profilePhotoUrl?: string;
    spokenLanguages?: string[];
    isPro?: boolean;
    professionTitle?: string;
    rating?: SellerInfoRating;
    summary?: string[];
    summaryMode: AISummaryMode;
    /**
     * React component that renders badge(s)
     */
    Badges?: React.FC;
}

export interface SellerInfoRating {
    rating: number;
    ratingsCount?: number;
    onReviewsClick?: () => void;
}
